import { useOffersDE } from '../../hooks/useOffers/useOffersDE';
import ApplicationLoader from '../ApplicationLoader/ApplicationLoader';
import OffersCheck from '../OffersCheck/OffersCheck';

const OffersWithOffersCheckDE = () => {
  const offersInformation = useOffersDE();

  return (
    <OffersCheck
      {...offersInformation}
      showMarketingPoll={offersInformation.isInExitPollTestDE}
    >
      <ApplicationLoader
        showMarketingPoll={offersInformation.isInExitPollTestDE}
      />
    </OffersCheck>
  );
};

export default OffersWithOffersCheckDE;
